import React from 'react';
import withTranslations from '../../utils/HighOrderComponent';
import KJSMunicipalityRow from './KJSMunicipalityRow';
import { Table, Card } from 'react-bootstrap';

const KJSMunicipalityTable = (props) => {
  const { kjsMunicipalityList, t, handleDeleteItem } = props || {};

  const items = kjsMunicipalityList?.map((kjsMunicipality, index) => (
    <KJSMunicipalityRow
      key={`kjsMunicipality_${kjsMunicipality.id}_${index}`}
      kjsMunicipality={kjsMunicipality}
      handleDelete={handleDeleteItem}
    />
  ));

  return (
    <Card className="kjs-municipality-default-table-height">
      <Card.Body>
        <Table responsive hover id="table" className="table table-sm">
          <thead>
            <tr className="text-center">
              <th className="text-left">{t.kjs}</th>
              <th width="14%">{t.delete}</th>
            </tr>
          </thead>
          <tbody>{items}</tbody>
        </Table>
      </Card.Body>
    </Card>
  );
};
export default withTranslations(KJSMunicipalityTable, 'KJSMunicipalityTable');
